import { useEffect } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchAllQuestionnaires = () => {
  const { apiGet } = useApi();
  const useApiState = createApiHook([]);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const fetchData = async () => {
    startLoading();
    const response = await apiGet("/questionnaires", "Error al obtener todos los cuestionarios");
    setResponse(response);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { data, error, loading, refetch: fetchData };
};

export default useFetchAllQuestionnaires;
